import React from "react";

export default function Mission() {
  const pillars = [
    { k: "01", t: "Real space assets", d: "Every deed maps to an actual astronomical body with a verifiable position — not invented art." },
    { k: "02", t: "Scientific foundation", d: "Provenance drawn from NASA, the IAU and USGS — the same catalogs astronomers use." },
    { k: "03", t: "Within space law", d: "A transparent registry of symbolic deeds, operated openly and recorded immutably on-chain." },
  ];
  return (
    <section id="mission" className="sec-pad" data-screen-label="Mission">
      <div className="wrap">
        <div className="sec-tag"><span className="idx">[ 01 ]</span> MISSION <span className="rule"></span> <span>HUMANITY · MULTI-PLANETARY</span></div>
        <h2 className="h-lg mission-h" data-reveal>
          We are building humanity's <span className="grad">multi-planetary</span> future — one verifiable deed at a time.
        </h2>
        <p className="lead mission-lead" data-reveal>
          NiftySky is a next-generation registry for tokenized space assets. We translate authoritative
          scientific data into ownable, tradeable on-chain deeds — bringing rigor, transparency and a sense
          of wonder to what it means to own a piece of the sky.
        </p>
        <div className="pillars">
          {pillars.map((p, i) => (
            <div className="pillar" data-reveal key={i} style={{ transitionDelay: i * 90 + "ms" }}>
              <div className="pillar-k mono">{p.k}</div>
              <div className="pillar-t">{p.t}</div>
              <div className="pillar-d">{p.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
